var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getHex, getContrast, alterLightness } from '../utils/functions/colorUtils';
// allows the creation of themes using any css color format
function createTheme(theme) {
    var completePalette = {};
    if (theme.palette) {
        // loop through every key in the palette (primary, secondary, succes, error, ...)
        Object.keys(theme.palette).forEach(function (key) {
            var value = theme.palette[key];
            // set main color to hex format
            var mainColor = getHex(value.main);
            completePalette[key] = { main: mainColor };
            // get ligther and darker shades from main color if not provided
            var shades = [
                ['lighter', 0.8],
                ['light', 0.2],
                ['dark', -0.2],
                ['darker', -0.8],
            ];
            shades.forEach(function (shade) {
                var newColor = theme.palette[key][shade[0]]
                    ? getHex(theme.palette[key][shade[0]])
                    : alterLightness(mainColor, shade[1]);
                completePalette[key][shade[0]] = newColor;
            });
            // finally add contrast color if not provided
            completePalette[key].contrast = getHex(theme.palette[key].contrast) || getContrast(mainColor);
        });
    }
    var fixedTheme = __assign(__assign({}, theme), { palette: completePalette });
    return fixedTheme;
}
export default createTheme;
